import {ActivityRiskReducer} from "./activity_risk_config";


export class ActivityControlReducer extends ActivityRiskReducer {

    secondary_key = 'control_area_id';



}